module.exports = __webpack_public_path__ + "static/media/cops-map.fd4a008d.png";